import React from "react";
import {pushLocation} from "../../../../../../../router";
import {LINK_WITHDRAWAL} from "../../../../../../../constants/links";

export const generateActionsList = (data) => {
  return [
    {
      name: 'Details',
      onClick() {
        const type = !!data.sc_code ? 'stablecoin' : 'fiat';

        pushLocation({
          path: `${LINK_WITHDRAWAL}/${type}/${data.id}`
        });
      },
    },
  ];
}
